document.addEventListener('DOMContentLoaded', () => {
  const vids = document.querySelectorAll('video.pdp-video');

  // Fallback for browsers without IntersectionObserver
  if (!('IntersectionObserver' in window)) {
    vids.forEach(v => { v.muted = true; v.play().catch(()=>{}); });
    return;
  }

  const io = new IntersectionObserver(entries => {
    entries.forEach(({ isIntersecting, target }) => {
      if (isIntersecting) {
        target.muted = true;
        target.play().catch(() => {});
      } else {
        target.pause();
      }
    });
  }, { threshold: 0.6 }); // 60% visible to play, feels smooth

  vids.forEach(v => io.observe(v));
});
